<template>
    <div class="overlay">
        <transition :name="overlay.transition"
                @enter="onScrollLockEnterHook"
                @afterLeave="onScrollLockAfterLeaveHook">
            <div class="overlay--root" v-if="overlay.isOpen">
                <div class="overlay--backdrop"></div>
                <div class="overlay--display">
                    <div class="overlay--wrap-outer">
                        <div class="overlay--wrap-inner">
                            <div class="overlay--backdrop-click-area" @click.prevent="closeOverlay"></div>
                            <div class="overlay--container">
                                <div class="overlay--revealer">
                                    <cmp-modal :facet="overlay.facet">
                                        <component :is="overlay.component" v-bind="overlay.props"></component>
                                    </cmp-modal>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import scrollLockHelperMixin from 'framework/mixins/scroll-lock-helper';


    export default {
        mixins: [
            scrollLockHelperMixin,
        ],
        computed: {
            ...mapGetters(['overlay']),
        },
        methods: {
            ...mapActions(['closeOverlay']),
        },
    };
</script>



// WEBPACK FOOTER //
// vehi-industriepfad/assets/src/js/app/framework/components/ui/overlay/index.vue?277cda78